module.exports = __webpack_public_path__ + "static/media/visa.1dcf2ba3.svg";